import { render } from "./TimerSpinner.vue?vue&type=template&id=835e78de&scoped=true"
const script = {}

import "./TimerSpinner.vue?vue&type=style&index=0&id=835e78de&lang=scss&scoped=true"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835e78de"]])

export default __exports__